// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"67":"035e12ef","431":"c8cb6e76","512":"e4499c18","735":"12013a49","881":"a2fbcbbd"}[chunkId] + ".chunk.css";
};